import { gql } from 'graphql-tag'

export const SET_MILEAGE = gql`
  mutation SetMileage($policyNumber: Float!, $mileageData: VehicleMileageOnQuoteInput!) {
    setMileage(policyNumber: $policyNumber, mileageData: $mileageData)
  }
`
